import React, { useState } from "react";
import Hamburger from "../../Hamburger";
import SideNavbar from "../../SideNavbar";
import "./Checkout.css";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { isAutheticated, signout } from "../../Auth.js";
import axios from "axios";
import toast from "react-hot-toast";
import mainlogo from "../../AllImage/reinventlogo.png";
import productPlaceholder from "../../AllImage/productPlaceholder.jpg";

const Checkout = () => {
  const token = isAutheticated();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [screenLoading, setScreenLoading] = useState(false);
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const [checkoutData, setCheckoutData] = useState({});

  useEffect(() => {
    function getAll() {
      setScreenLoading(true);
      Promise.all([
        axios.get("/api/client/checkout/v2", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
      ])
        .then((res) => {
          setCheckoutData(res[0].data?.data || {});
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || "Something went wrong!");
          navigate("/cart");
        })
        .finally(() => setScreenLoading(false));
    }
    getAll();
  }, [navigate, token]);

  const toggleHamburger = () => {
    setHamburgerOpen(!hamburgerOpen);
  };

  const handleCheckOut = () => {
    setLoading(true);
    axios
      .get(`/api/client/checkout/proceedtopayment`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setLoading(false);
        const data = res.data.data;

        const options = {
          key: res.data?.api_key_id,
          amount: data.total_amount,
          currency: "INR",
          name: "Reinvent Uniforms",
          description: "Buy products",
          image: mainlogo,
          order_id: data.razorpay_order_id,
          handler: function (response) {
            onPayment(response);
          },
          prefill: {
            name: data.name,
            email: data.email,
          },
          theme: {
            color: "#3399cc",
          },
        };
        var rzp1 = new window.Razorpay(options);
        rzp1.open();
        rzp1.on("payment.failed", function (response) {
          onPayment(
            { razorpay_order_id: response.error.metadata.order_id },
            false,
          );
        });
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message || "Something went wrong!");
      });
  };

  function onPayment(response, success = true) {
    axios
      .post(`/api/client/payment/onpayment`, { ...response, success })
      .then((res) => {
        navigate(`/order/confirmation/${res.data.order_id}`);
      })
      .catch((err) => toast.error("Payment failed!"));
  }

  return (
    <>
      <div className="">
        <div className="Productmenu  ">
          <div className="submain mt-4">
            <Link
              to="/dashboard"
              style={{ textDecoration: "none", color: "black" }}
            >
              Dashboard
            </Link>

            <p className=" mt-3 ">
              <Link
                to="/select_child"
                style={{ textDecoration: "none", color: "black" }}
              >
                Products
              </Link>
            </p>
            <p>
              <Link
                to="/order/history"
                style={{ textDecoration: "none", color: "black" }}
              >
                Order History
              </Link>
            </p>
            <p>
              <Link
                to="/child/add"
                style={{ textDecoration: "none", color: "black" }}
              >
                Children
              </Link>
            </p>
            <p>
              <Link
                to="/support_system"
                style={{ textDecoration: "none", color: "black" }}
              >
                Support
              </Link>
            </p>

            <p className=" mt-3 ">
              <Link
                to="/profile"
                style={{ textDecoration: "none", color: "black" }}
              >
                My Profile
              </Link>
            </p>
            <p onClick={() => signout()}>
              <Link style={{ textDecoration: "none", color: "black" }}>
                Logout
              </Link>
            </p>
          </div>
        </div>

        <div className="hamburger" onClick={toggleHamburger}>
          <Hamburger isOpen={hamburgerOpen} />
        </div>

        <SideNavbar hamburgerOpen={hamburgerOpen} />

        <div className="contentDivs">
          <h1
            className="d-flex justify-content-center"
            style={{
              paddingTop: "3%",
              paddingBottom: "3%",
            }}
          >
            Checkout
          </h1>

          {screenLoading ? (
            <div className="text-center" style={{ minHeight: "500px" }}>
              <div className="spinner-grow" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              <div className="row container pb-5">
                <div className="col-xl-8 mt-4">
                  <div className="card mx-auto">
                    <div className="card-body">
                      <h3 className="mt-3 text-center">Items</h3>
                      <div className="mt-1">
                        {checkoutData?.items?.length > 0 &&
                          checkoutData.items.map((e, i) => (
                            <div key={i} className="my-2">
                              <div className="row">
                                <div className="col-md-4">
                                  <img
                                    src={
                                      e.product?.images?.length > 0
                                        ? e.product?.images[0]?.url
                                        : productPlaceholder
                                    }
                                    alt={e.product.name}
                                    className="checkout-img"
                                  />
                                </div>
                                <div
                                  className="col-md-8 checkout-item-info"
                                  style={{ fontSize: "14px" }}
                                >
                                  <h5 className="m-0 p-0">{e.product_name}</h5>
                                  <p className="m-0 p-0">
                                    <span>Enrollment No.</span>:{" "}
                                    {e?.enrollment_number || "-"}
                                  </p>
                                  <p>
                                    <span>Size</span>: {e.variant.size?.size}
                                  </p>
                                  <p>
                                    <span>Price:</span> Rs. {e.price}
                                  </p>
                                  {e?.igst && (
                                    <p>
                                      <span>IGST:</span> {e.igst}%
                                    </p>
                                  )}
                                  {e?.cgst && (
                                    <p>
                                      <span>CGST:</span> {e.cgst}%
                                    </p>
                                  )}
                                  {e?.sgst && (
                                    <p>
                                      <span>SGST:</span> {e.sgst}%
                                    </p>
                                  )}
                                  <p>
                                    <span>Quantity:</span> {e.quantity}
                                  </p>
                                  <p>
                                    <span>Total:</span> Rs. {e.amount}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 mt-4">
                  <div
                    className="card priceCard"
                    style={{
                      background: "#C9ADA7",
                    }}
                  >
                    <div className="card-body">
                      <h4 className="card-title">Checkout Details</h4>
                      <div className="d-flex justify-content-between mb-1">
                        <label className="form-label ms-3">
                          <strong>Gross Amount :</strong>
                        </label>
                        <strong> Rs {checkoutData?.total_gross_amount}</strong>
                      </div>
                      <div className="d-flex justify-content-between mb-1">
                        <label className="form-label ms-3">
                          <strong>Shipping Charge :</strong>
                        </label>
                        <strong>
                          Rs {checkoutData?.shipping_charge_without_tax}
                        </strong>
                      </div>
                      <div className="d-flex justify-content-between mb-1">
                        <label className="form-label ms-3">
                          <strong>Tax Amount :</strong>
                        </label>
                        <strong> Rs {checkoutData?.tax_amount}</strong>
                      </div>
                      <hr style={{ margin: "0" }} />
                      <div className="mb-3 d-flex justify-content-between">
                        <label className="form-label ms-3">
                          <strong>Total Amount :</strong>
                        </label>
                        <strong> Rs {checkoutData?.total_amount}</strong>
                      </div>
                      {checkoutData?.remarks && (
                        <div
                          className="my-2 mx-1 alert alert-primary"
                          style={{
                            display: "block",
                            whiteSpace: "pre-wrap",
                            overflowWrap: "break-word",
                            fontSize: 12,
                            padding: "3px 7px",
                          }}
                          role="alert"
                        >
                          {checkoutData?.remarks}
                        </div>
                      )}
                      <div className="mb-3 d-grid">
                        <button
                          className="btn btn-dark mt-4"
                          onClick={handleCheckOut}
                          disabled={loading}
                        >
                          Pay and Place Order
                        </button>
                        <Link
                          to="/cart"
                          class="btn btn-success mt-3"
                          data-abc="true"
                        >
                          Edit Cart
                        </Link>
                        <Link
                          to="/select_child"
                          class="btn btn-primary mt-3"
                          data-abc="true"
                        >
                          Continue Shopping
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Checkout;
